<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“Engaged, collaborative, and focused.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a visible sign of <span class="font-bold"
        >cultural alignment.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People aren’t just working - they’re energized, connected, and clear on
      why it matters.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      It’s like walking through a submarine and hearing every department running
      drills on their own - they don’t need direction, they’re dialed in.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >What’s fueling that energy - and how do we keep it going under
        pressure?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Celebrate that rhythm, then build it into your systems so it doesn’t rely
      on good weeks or personalities alone.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“Busy, but unsure if aligned.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This signals a team that’s active - but <span class="font-bold"
        >not anchored.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People are working hard, but possibly toward different outcomes or
      disconnected goals.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In high-performing crews, busy isn’t enough. Every role must tie back to
      mission success - not just motion.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Use short stand-ups or check-ins to reinforce: <span class="italic"
        >Here’s what we’re doing. Here’s why. Here’s where you fit.
      </span>
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Realignment doesn’t always need a new strategy - sometimes it just needs a
      louder voice at the helm.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“A little checked out or siloed.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a warning light - <span class="font-bold"
        >you’ve got functional drift and emotional disengagement.</span
      >
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      If teams are pulling in different directions - or not pulling at all -
      then alignment isn’t broken, it’s absent.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Check the oxygen in the system. Reignite purpose by asking: <span
        class="italic"
        >Do we know why this work matters - to our mission and to each other?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Sometimes alignment isn’t about more goals - it’s about more meaning.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“Tired, reactive, and going through the motions.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is more than misalignment - <span class="font-bold"
        >it’s cultural depletion.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People have lost the connection between effort and impact.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      If your crew is running low on energy, clarity, and direction, it’s only a
      matter of time before burnout hits - or turnover does.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      You need a reactivation moment. Not perks - purpose.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Host a mission reset. Ask: <span class="italic"
        >What are we solving for, and what would it take to believe in it again?
      </span>
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Your people want to care - but they need the signal to do so.
    </p>
  {/if}
</div>
